import { createSlice, current } from '@reduxjs/toolkit';
import {
	getBreachTypeOfEvidenceList,
	getBreachTypeOfEvidence,
	addNewBreachTypeOfEvidence,
	updateBreachTypeOfEvidence,
	deleteBreachTypeOfEvidence,
	checkBreachTypeOfEvidenceExists,
} from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
	breachTypeOfEvidenceList: [],
	breachTypeOfEvidenceListSelect: [],
	isLoadingList: false,
	isSuccess: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const BreachTypeOfEvidenceSlice = createSlice({
	name: 'BreachTypeOfEvidence',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		// ── List ──
		builder.addCase(getBreachTypeOfEvidenceList.pending, state => {
			state.isLoadingList = true;
			state.isSuccess = false;
		});
		builder.addCase(getBreachTypeOfEvidenceList.fulfilled, (state, action) => {
			const list = action.payload || [];
			state.breachTypeOfEvidenceList = list;
			state.breachTypeOfEvidenceListSelect = list.map(item => ({
				item,
				value: item._id,
				label: getOptionLabel(item),
			}));
			state.isLoadingList = false;
			state.isSuccess = true;
		});
		builder.addCase(getBreachTypeOfEvidenceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSuccess = false;
		});

		// ── Add ──
		builder.addCase(addNewBreachTypeOfEvidence.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewBreachTypeOfEvidence.fulfilled, (state, action) => {
			state.breachTypeOfEvidenceList.push(action.payload);
			state.breachTypeOfEvidenceListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: getOptionLabel(action.payload),
			});
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewBreachTypeOfEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		// ── Update ──
		builder.addCase(updateBreachTypeOfEvidence.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateBreachTypeOfEvidence.fulfilled, (state, action) => {
			state.breachTypeOfEvidenceList = state.breachTypeOfEvidenceList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.breachTypeOfEvidenceListSelect = state.breachTypeOfEvidenceListSelect.map(opt =>
				opt.value.toString() === action.payload._id.toString()
					? { item: action.payload, value: action.payload._id, label: getOptionLabel(action.payload) }
					: opt
			);
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});
		builder.addCase(updateBreachTypeOfEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		// ── Delete ──
		builder.addCase(deleteBreachTypeOfEvidence.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteBreachTypeOfEvidence.fulfilled, (state, action) => {
			state.breachTypeOfEvidenceList = current(state.breachTypeOfEvidenceList).filter(
				item => item._id !== action.payload._id
			);
			state.breachTypeOfEvidenceListSelect = current(
				state.breachTypeOfEvidenceListSelect
			).filter(opt => opt.value !== action.payload._id);
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteBreachTypeOfEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		// ── Check exists ──
		builder.addCase(checkBreachTypeOfEvidenceExists.pending, state => {
			state.exists = false;
		});
		builder.addCase(checkBreachTypeOfEvidenceExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});
		builder.addCase(checkBreachTypeOfEvidenceExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = BreachTypeOfEvidenceSlice.actions;

export default BreachTypeOfEvidenceSlice.reducer;
